import { render } from "./shiftSetup.vue?vue&type=template&id=e41112ce&scoped=true"
import script from "./shiftSetup.vue?vue&type=script&lang=js"
export * from "./shiftSetup.vue?vue&type=script&lang=js"

import "./shiftSetup.vue?vue&type=style&index=0&id=e41112ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e41112ce"]])

export default __exports__